import {Vector3} from 'three'

import {CORNER_RADIUS} from '../../modules/cube/_config'

const basePosition = new Vector3(0.0, -1, 0.0)

const calcPosition = (pos: Vector3) => {
  pos.add(basePosition)
  pos.x *= 1.0 + CORNER_RADIUS * 1.1
  pos.y *= 1.0 + CORNER_RADIUS * 1.1
  pos.z *= 1.0 + CORNER_RADIUS * 1.1

  return pos
}

export default [
  {
    position: new Vector3(0, -1.2, 0),
    rotation: new Vector3(Math.PI * 0.5, Math.PI * 0.5, 0),
    cubeType: 'invertocat',
    offsetStart: {
      position: new Vector3(0, -4, 0),
      rotation: new Vector3(-Math.PI, 0, 0),
    },
    delay: 0,
    duration: 1.5,
    scale: 1.5,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(2.0, 0.6, -2.0)),
    rotation: new Vector3(0, 0, Math.PI),
    cubeType: 'invertocat',
    offsetStart: {
      position: new Vector3(0, -3, 0),
      rotation: new Vector3(0, 0, 0),
    },
    delay: 0,
    duration: 1.5,
    scale: 1,
    layout: {
      tablet: {
        offset: new Vector3(-0.4, 0, 0.4),
        visible: true,
      },
      mobile: {
        offset: new Vector3(-1.5, 0, 1.5),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(3, 0.0, -3)),
    rotation: new Vector3(0.0, Math.PI * 0.5, Math.PI * 0.5),
    cubeType: 'invertocat',
    isGlassRender: false,
    offsetStart: {
      position: new Vector3(0, -3, 0),
      rotation: new Vector3(0, 0, 0),
    },
    delay: 0.0,
    duration: 1,
    scale: 1,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
]
